const getPageSchema = (pageSchema) => {
  const pageSchemas = pageSchema.map(({ title, content }) => [
    {
      '@type': 'Question',
      name: title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: content,
      },
    },
  ]);

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: pageSchemas,
  };
};

export default getPageSchema;
